<template>
    <div class="container_content">
        <div class="M_search">
            <el-input placeholder="请输入类型" v-model="params.type" style="width: auto"/>
            <el-button icon="el-icon-search" @click="searchChange" type="primary" size="small"
                       style="margin-left: 10px">搜 索
            </el-button>
            <el-button icon="el-icon-refresh" @click="emptySearch">清 空</el-button>
            <el-button
                    :disabled="deleteState"
                    style="float: right"
                    type="danger"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
            >删除
            </el-button>
            <el-button style="float: right" type="success" @click="handleAdd" icon="el-icon-plus">新 增</el-button>
        </div>
        <div class="tableHeight2">

            <el-table border :data="tableData" height="100%" v-loading="tableLoading" stripe
                      tooltip-effect="dark"
                      style="min-width: 100%;min-height: 100%" fit highlight-current-row
                      @selection-change="handleSelectionChange">
                <el-table-column
                        type="selection"
                        width="55"
                        :selectable="checkSelectable"
                        align="center">
                </el-table-column>
                <el-table-column type="index" label="序号" width="65" align="center"></el-table-column>
                <el-table-column prop="type" label="类型" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="description" label="描述" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="remarks" label="备注" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="170" show-overflow-tooltip
                                 align="center"></el-table-column>
                <el-table-column width="100" prop="createTime" label="字典项" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleItem(scope.row)">管理</el-button>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleEdit(scope.row,scope.index)">编辑</el-button>
<!--                        <el-button style="color: rgba(255,0,0,0.58)" disabled type="text" v-if="scope.row.system==1"-->
<!--                                   @click="handleDel(scope.row)">删除-->
<!--                        </el-button>-->
<!--                        <el-button style="color: red" type="text" v-else @click="handleDel(scope.row)">删除</el-button>-->
                        <!--                        <el-button type="text" @click="handleItem(scope.row)">字典项</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-container" style="text-align: right">
            <el-pagination background @size-change="changeSize" @current-change="changePage"
                           :current-page="page.currentPage"
                           :page-sizes="page.sizes"
                           :page-size="page.pageSize" layout="total,sizes, prev, pager, next" :total="page.total">
            </el-pagination>
        </div>
        <dict-item ref="dictItem" :itemData="itemData" @closeItem="closeItem"></dict-item>
        <dict-add ref="addModal" :addData="addData" @closeAdd="closeAdd"></dict-add>
        <dict-edit ref="editModal" :editData="editData" @closeEdit="closeEdit"></dict-edit>
    </div>
</template>

<script>
    import {addObj, delObj, deleteS, fetchList, putObj} from '@/api/admin/dict'
    import dictItem from "@/components/dialog/dictManage/itemList";
    import dictAdd from "@/components/dialog/dictManage/addList"; //添加
    import dictEdit from "@/components/dialog/dictManage/editList"; //编辑

    export default {
        name: 'dict',
        components: {dictItem, dictAdd, dictEdit},
        data() {
            return {
                deleteState: true,
                multipleSelection: [],
                delList: [],
                tableData: [],
                page: {
                    total: 0, // 总页数
                    currentPage: 1, // 当前页数
                    pageSize: 10,// 每页显示多少条
                    sizes: [10, 20, 50, 100]
                },
                tableLoading: false,
                params: {
                    label: null,
                    type: null
                },
                title: '新增',
                showModel: false,
                addForm: {
                    id: null,
                    value: '',
                    type: '',
                    label: '',
                    description: '',
                    remarks: '',
                    sort: 0,
                    sysFlag: 0
                },
                sysFlag: true,
                itemData: {
                    state: false,
                    data: null
                },
                addData: {
                    state: false,
                    data: null
                },
                editData: {
                    state: false,
                    data: null
                }
            }
        },
        created() {
        },
        mounted: function () {
            this.getList(this.page, this.params);
        },
        methods: {
            // 设置表格行不可选
            checkSelectable(row, index) {
                if (row.system == 1) {
                    return false;
                }
                return true;
            },
            delAllSelection() {
                this.$confirm(
                    "点击“确定”按钮删除选中内容，否则请点击“取消”按钮！",
                    "信息消息",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "关闭",
                        type: "warning"
                    }
                ).then(() => {
                    this.delList = this.delList.concat(this.multipleSelection);
                    const idArr = this.multipleSelection.map(item => {
                        return item.id;
                    });
                    console.log(idArr,'idArr');
                    deleteS(idArr).then(res => {
                        if (res.data.code == 0) {
                            if (this.tableData.length === idArr.length && this.page.currentPage > 1) {
                                this.page.total -= 1;
                                this.page.currentPage -= 1;
                            }
                            this.$message.success(`删除成功`);
                            this.multipleSelection = [];
                            this.getList(this.page, this.params);
                        }
                    });
                })
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (this.multipleSelection.length > 0) {
                    this.deleteState = false
                } else {
                    this.deleteState = true
                }
            },
            /**
             * @description: 关闭新增
             * @param:{obj}
             * @return:
             */
            closeAdd(obj) {
                this.addData.state = false;
                this.getList(this.page, this.params);
            },
            /**
             * @description: 新增
             * @param:{}
             * @return:
             */
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd: function () {
                this.addData.state = true
            },
            getList(page, params) {
                this.tableLoading = true;
                fetchList(Object.assign({
                    current: page.currentPage,
                    size: page.pageSize
                }, params)).then(response => {
                    this.tableData = response.data.data.records;
                    this.page.total = response.data.data.total;
                    this.tableLoading = false
                })
            },
            /**
             * @description: 关闭编辑
             * @param:{obj}
             * @return:
             */
            closeEdit(obj) {
                this.editData.state = false;
                this.getList(this.page, this.params);
            },
            handleEdit(row) {
                this.editData.data = row;
                this.editData.state = true;
                this.$refs.editModal.showEditData();
            },
            handleReset() {
                this.showModel = false
                this.addForm = {
                    id: null,
                    value: '',
                    type: '',
                    label: '',
                    description: '',
                    remarks: '',
                    sort: 0,
                    sysFlag: 0
                };
            },
            /**
             * @description: 关闭
             * @param:{}
             * @return:
             */
            closeItem(obj) {
                this.itemData.state = false;
                this.getList(this.page, this.params);
            },
            /**
             * @description: 查看字典项
             * @param:{}
             * @return:
             */
            handleItem(row) {
                this.itemData.data = row;
                this.itemData.state = true;
                this.$refs.dictItem.getItemList();
            },
            /**
             * @description: 删除
             * @param:{}
             * @return:
             */
            handleDel: function (row) {
                this.$confirm('"是否确认删除数据类型为"' + row.type + '"的数据项?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delObj(row.id).then(res => {
                        if (res.data.code == 0) {
                            this.getList(this.page, this.params);
                        } else {
                            this.$alert(res.data.msg, '提示', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            });
                        }
                    })
                }).catch(function () {
                })
            },
            /**
             * 字典更新
             **/
            handleUpdate: function () {
                this.addForm.sysFlag = this.sysFlag ? 0 : 1;
                putObj(this.addForm).then(() => {
                    this.$message({
                        showClose: true,
                        message: '修改成功',
                        type: 'success'
                    })
                    this.getList(this.page, this.params);
                    this.showModel = false;
                })
            },
            /**
             * 字典添加
             **/
            handleSave: function () {
                this.addForm.sysFlag = this.sysFlag ? 0 : 1;
                addObj(this.addForm).then(data => {
                    this.tableData.push(Object.assign({}, this.addForm))
                    this.$message({
                        showClose: true,
                        message: '添加成功',
                        type: 'success'
                    })
                    this.getList(this.page, this.params);
                    this.showModel = false;
                })
            },
            searchChange() {
                this.page.currentPage = 1;
                this.getList(this.page, this.params)
            },
            emptySearch() {
                this.params = {label: null, type: null};
                this.getList(this.page, this.params)
            },
            changePage(num) {
                this.page.currentPage = num;
                this.getList(this.page, this.params);
            },
            changeSize(size) {
                this.page.pageSize = size;
                this.page.currentPage = 1;
                this.getList(this.page, this.params);
            }
        }
    }
</script>

<style lang="less" scoped>
    .execution {
        height: 100%;
        background: #fff;
    }

    .valueModal {
        .ivu-date-picker {
            width: 100%;
        }

        .ivu-radio-group {
            height: 32px;
            line-height: 32px;
            margin-bottom: 20px;
            padding-left: 30px;
            font-size: 16px;
        }
    }
</style>

